import { teal } from '@mui/material/colors';
import Grid from '@mui/material/Grid';
import React from 'react';
import AboutSelect from '../../components/About/AboutSelect';
import AffiliateText from '../../components/About/Texts/Affiliates';
import Footer from '../../components/General/Footer';
import HeaderCard from '../../components/General/HeaderCard';
import Head from '../../components/Header/Head';
import Header from '../../components/Header/Header';
import withApollo from '../../lib/withApollo';

const PrivacyPage = () => {
  const title = 'Affiliate Disclosure';
  return (
    <>
      <Header subheader={title} active="affiliate-disclosure" />
      <Head title={`${title}`} />
      <AboutSelect selection={8} />
      <Grid
        container
        spacing={0}
        alignItems="center"
        justifyContent="center"
        className="pt-4 pb-4"
      >
        <Grid item lg={7} md={8} sm={11} xs={12}>
          <HeaderCard
            title={title}
            background={teal[600]}
            content={<AffiliateText />}
          />
        </Grid>
      </Grid>
      <Footer />
    </>
  );
};

export default withApollo(PrivacyPage);
